// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingLanguagesPanel_root__3-OIP","form":"EditListingLanguagesPanel_form__GU6B5","title":"EditListingLanguagesPanel_title__3IXg7"};